<script setup lang="ts">
import { cn } from "@/lib/utils"
import { ComboboxContent, type ComboboxContentProps } from "reka-ui"
import { computed, type HTMLAttributes } from "vue"

const props = defineProps<ComboboxContentProps & { class?: HTMLAttributes["class"] }>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props
  return delegated
})
</script>

<template>
  <ComboboxContent
    v-bind="delegatedProps"
    :class="cn('max-h-[300px] overflow-y-auto overflow-x-hidden', props.class)"
  >
    <slot />
  </ComboboxContent>
</template>
